export default {
	title: "VIP Level",
	current: "Current VIP Level",
	status: {
		btn: ["Activated", "Register Now"]
	}
};
